import Modal from '@viking-eng/modal';
import MvjPropTypes from '@viking-eng/prop-types';
import PropTypes from 'prop-types';

import './BookingActionModal.scss';

const BookingActionModal = ({ children, id, onClose, title }) => (
  <Modal id={id} onClose={onClose}>
    <div className="booking-action-modal">
      <div className="mvj-modal">
        <div className="row no-gutters d-flex justify-content-center">
          <div className="col-11">
            <div className="title h5 h3-md">{title}</div>
            {children}
          </div>
        </div>
      </div>
    </div>
  </Modal>
);

BookingActionModal.propTypes = {
  children: MvjPropTypes.jsx,
  id: PropTypes.string,
  title: PropTypes.string.isRequired,
  user: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  onClose: PropTypes.func.isRequired,
};

BookingActionModal.defaultProps = {
  children: null,
  id: '',
  user: {},
};

export default BookingActionModal;
